import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getModelsService = async () => {
  const response = await getData("maintenance/model/get");
  return response;
};

export const createNewModelService = async (payload) => {
  const response = await putData("maintenance/model/create", payload);
  return response;
};

export const saveModelService = async (payload) => {
  return await postData("maintenance/model/update", payload);
};

export const deleteModelService = async (payload,type) => {
  if(type === "region"){
    return await deleteData(`region/delete?regionId=${payload}`);
  }
  else if(type === "market"){
    return await deleteData(`market/delete?marketId=${payload}`);
  }
  else if(type === "office"){
    return await deleteData(`salesOffice/delete?salesOfficeId=${payload}`);
  }
};

// Replaceable Text
export const createRepTextService = async (payload) => {
  return await putData("maintenance/replaceableText/create", payload);
};

export const saveRepTextService = async (payload) => {
  return await postData("maintenance/replaceableText/update", payload);
};

export const deleteRepTextService = async (payload) => {
  return await deleteData("maintenance/replaceableText/delete", payload);
};

export const getRegionsService = async () => {
  return await getData("region/get");
  //return await getData("/dummyJSON/region.json");
};

export const sortMoelService = async (payload) => {
  return await postData("maintenance/replaceableText/updateMultiple", payload);
};

export const copySequenceInModel = async (payload) => {
  return await postData("maintenance/CopyReplaceableTxt", payload);
};

export const salesOfficeFetch = async(payload) => {
  //return await getData("/dummyJSON/salesOffice.json");
  return await getData(`salesOffice/getByRegion/?regionId=${payload.regionId}`);
}

export const marketOfficeFetch = async(payload) => {
  //return await getData("/dummyJSON/market.json");
  return await getData(`market/getBySalesOffice/?salesOfficeId=${payload.salesOfficeId}`);
}

export const createNewRegionService = async(payload) => {
  return await putData("region/create",payload);
}

export const updateRegionSalesMarketService = async(payload,type) => {
  if(type === "region"){
    return await postData(`region/update/?regionId=${payload.regionId}`,payload);
  }
  else if(type === "market"){
    return await postData(`market/update/?marketId=${payload.marketId}`,payload);
  }
}

export const addNewMarketService = async(payload) => {
  return await putData('market/create',payload);
}

export const currencyFetch = async() => {
  return await getData("currency/get");
}

export const createNewSalesOfficeService = async(payload) => {
  return await putData("salesOffice/create",payload);
}

export const updateSalesOfficeService = async(payload) => {
  return await postData(`salesOffice/update/?salesOfficeId=${payload.salesOfficeId}`,payload);
}